module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Armless Sofa_Stone.b0713448.png";